import * as React from "react";
import { Icon } from "antd";
// import { PositionProperty } from "../../../node_modules/csstype";
import DrawerTransfer from "./drawerTransfer";
import { connect } from "react-redux";
import { IFieldDrawer } from "../../utils/interface/smallTools";

// interface IFieldDrawer {
//   // 原始数据
//   data?: any;
//   // 回调事件
//   onSubmit?: any;
//   // 关联组件的名称
//   componentName?: any;
//   // 应用程序唯一
//   uuid?: any;
//   settInfo?: any;
//   getSett?: any;
//   saveSett?: any;
// }

// 控制字段显示/隐藏功能组件
class FieldDrawer extends React.Component<IFieldDrawer, any> {
  state = {
    targetKeys: [],
    destroyDrawerTansfer: () => {}
  };

  constructor(props: IFieldDrawer) {
    super(props);
    // 获取localStorage中保存的配置信息并更新Redux中的数据
    // this.props.getSett({
    //   uuid: 666,
    //   name: this.props.componentName
    // });
    // setTimeout(() => {
    //   this.props.onSubmit(this.props.settInfo[this.props.componentName]);
    // }, 200);
    // console.log("FieldDrawer");
  }

  // componentWillUpdate(nextProps, nextState) {

  //   if (nextProps.settInfo[nextProps.componentName]) {
  //     nextProps.onSubmit(nextProps.settInfo[nextProps.componentName]);
  //   }
  // }

  showDrawer = () => {
    const settInfo = this.props.settInfo;
    const targetKeys = settInfo[this.props.componentName];

    DrawerTransfer.newInstance(
      {
        ...this.props,
        targetKeys: targetKeys,
        onSubmit: this.onSubmit,
        onClose: this.onClose
      },
      ({ destroy }) => {
        this.setState({
          destroyDrawerTansfer: destroy
        });
      }
    );
  };

  // 销毁字段显示/隐藏面板
  drawerTransferDestroy() {
    if (
      this.state.destroyDrawerTansfer &&
      typeof this.state.destroyDrawerTansfer === "function"
    ) {
      this.state.destroyDrawerTansfer();
    }
  }

  onClose = () => {
    this.drawerTransferDestroy();
  };

  // 保存
  onSubmit = targetKeys => {
    this.props.onSubmit(targetKeys);
    this.props.saveSett({
      uuid: 666,
      name: this.props.componentName,
      settInfo: targetKeys
    });
    this.drawerTransferDestroy();
  };

  render() {
    const style = {
      // position: "absolute" as PositionProperty,
      // color: "#1890ff",
      // top: -16,
      // right: 0,
      // cursor: "pointer"
    };

    return (
      <React.Fragment>
        <Icon
          type="setting"
          title="配置字段"
          style={style}
          onClick={this.showDrawer}
        />
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  settInfo: state.extFunc
});

const mapDispatch = dispatch => {
  return {
    getSett: dispatch.extFunc.getSett,
    saveSett: dispatch.extFunc.saveSett
  };
};

export default connect(
  mapState,
  mapDispatch
)(FieldDrawer);
